<template>
  <div :class="['sub-registro-content', classe]">
    <slot />
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Separador from "@/components/Fields/Separador/Separador.vue";
export default {
  name: "SubRegistro",

  props: {
    classe: Object | Array
  },

  components: {
    BaseLegal,
    Cabecalho,
    Separador
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.sub-registro-content {
  border: 1px dashed;
  padding: 0.5rem 0.642rem;
}
.cabecalho {
  label {
    font-size: 14px;
    font-weight: 600;
  }
}

.pis_cofins {
  border-color: #b40431;
}

.ipi {
  border-color: var(--ipi);
}

@media only print {
  .pis_cofins {
    border-color: var(--print-borda);
  }

  .ipi {
    border-color: var(--print-borda);
  }
}
</style>
